<template>
    <div class="scrollable-container">
        <br /> 
        <div id="create-new-task-button" class="order-1 order-md-1" >
            <!-- Focus button -->
            <!-- <b-button v-if="showLocationFilters" size="sm" id="focusButton" @click="changeScreenWidth"> Focus on Content <i class="fa-solid fa-arrows-left-right"></i> </b-button> -->
            <!-- table Search -->
            <div id="searchTask">
                <b-input-group  size="sm">
                    <template #prepend><b-input-group-text>Search</b-input-group-text></template>
                    <b-input v-model="filter" placeholder="Search for a task..."></b-input>
                </b-input-group>    
            </div>  
            <!-- Create new task button -->
            <b-button variant="primary" @click="createNewTask" v-b-modal="'new-contract-modal'" size="sm" :disabled="!isEditAllowed()">
                <i class="fa-solid fa-plus"></i><span> Create New Task</span>
            </b-button>
        </div>
        <div id="task-cal-container" class="d-flex flex-column flex-md-row">
            <b-col md="auto"  class="order-3 order-md-2">  
				<div style="margin-top: -30px; margin-left: -10px">
					<!-- mini calenadr -->
					<!-- <b-calendar
						style=" min-height: 270px; max-height: 270px; border-bottom: 1px '#dee2e6'; "
						nav-button-variant="primary"
						readonly
						selected-variant="transparent"
						id="mini-cal"
						v-model="selectedDate"
						:reset-button="false"
						:today-button="false"
						:date-info-fn="dateInfoFn"
						start-weekday="1"
						locale="en"
					>
					</b-calendar> -->

					<div id="filter-containers" >
                        <div id="showCompletedTaskcheckbox"> 
                            <b-form-checkbox switch v-model="showCompletedTasks" @change="updateCalendarItems">    
                                Show Completed Tasks  <i class="fa-regular fa-circle-check"></i>
                            </b-form-checkbox>
                        </div>
						<!-- <hr id="separating-line"/>   	 -->
						<!-- site filter -->
						<div>
							<div v-if="showLocationFilters"> <strong> Filter by Location</strong>  <span v-if="isEditAllowed()" style="margin-left: 70px; cursor: pointer;" @click="openColourModal"> <i class="fa-solid fa-gear"></i> </span> </div>
                            <div v-if="showLocationFilters">
                                <b-form-checkbox v-model="allSelected" @change="toggleAll" style="margin-left:5px">    
                                    {{ allSelected ? 'Select all location' : 'Select all location' }} 
                                </b-form-checkbox>
                            </div>
							<div v-if="showLocationFilters" class="scrollable-container-location">    
								<b-form-checkbox-group id="site-filter" v-model="selected" stacked @change="updateCalendarItems" style="margin-left:20px;">
									<b-form-checkbox v-for="option in huonLocationOptions" :key="option.value" :value="option.value"> 
										{{ option.calendar_category_colour}}
										<div class="category-item"> 
											<span class="category-dot" :style="' background-color: ' + (option.class != undefined ? option.class : 'grey')"></span> 
											<div class="category-label">  {{ option.label }} </div>
										</div>
									</b-form-checkbox>
								</b-form-checkbox-group>
							</div>   
                            <hr id="separating-line" />
							<!-- Category Filter -->
							<div style="margin-top: 10px"> <strong> Filter by Category</strong> </div>
                            <div> 
                                <b-form-checkbox v-model="allCategoriesSelected" @change="toggleAllCategories" style="margin-left:5px">    
                                    {{ allCategoriesSelected ? 'Select all categories' : 'Select all categories' }} 
                                </b-form-checkbox>
                            </div>
							<div class="scrollable-container-Category"> 
								<b-form-checkbox-group id="site-filter" v-model="Categoryselected" stacked @change="updateCalendarItems" style="margin-left:20px; padding-bottom: 10px;">
									<b-form-checkbox v-for="option in huonTaskCategoryOptions" :key="option.value" :value="option.value"> 
										{{ option.value }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</div>
						</div>
					</div>
				</div>                
            </b-col>

            <b-col id="Calendar-Tasks-Container"  class="order-2 order-md-3">
                <!-- tabs -->
                <b-tabs id="taskTabs" >
                    <b-tab title="Calendar" active>
                        <!-- large calendar -->
                        <calendar-view id="calendarview"                                 
                            :show-date="showDate"
                            :items="items"
                            :enableDragDrop="enableDragDrop"
                            @click-item="calTaskClick"
                            @drop-on-date="handelDropOnDate"
                            @dblclick="handleDoubleClick" 
                            @click-date="handleClickDate"
                            class="theme-default"
                            :class="{ 'week-view': currentView === 'week' }"
                            :startingDayOfWeek="1"
                            :display-period-uom="displayview"
                            :item-content-height="weekViewItemHeight"
                            :item-top="weekViewitemTop"
                            :display-period-count="displayPeriodCount"
                            @item-mouseenter="itemMouseEnter"
                            @item-mouseleave="itemMouseLeave"
                            :doEmitItemMouseEvents="true"                   
                        >
                            <!-- <calendar-view-header 
                                slot="header" 
                                slot-scope="t" 
                                :header-props="t.headerProps"
								@input="setShowDate"
                            /> -->
                            <template v-slot:header="t">
                                <calendar-view-header :header-props="t.headerProps" @input="setShowDate" />
                                <div class="cv-header-nav" style="position: relative; background-color: rgb(240, 240, 240); margin: 0px; border-style: solid; border-color: #ddd; border-width: 1px 1px 0 1px; padding: 10px;">
                                    <div style="position: absolute; left: 0;">
                                        <!-- <button @click="handlePreviousYearClick">pre y</button> -->
                                        <button @click="handleTodayClick">Today</button>
                                        <button @click="handlePreviousPeriodClick">
                                            <i class="fa-solid fa-chevron-left" style="padding-left: 2px;"></i>
                                        </button>
                                        <button @click="handleNextPeriodClick" class="nextPeriod">
                                            <i class="fa-solid fa-chevron-right" style="padding-left: 2px;"></i>
                                        </button>
                                        <!-- <button @click="handleNextYearClick" class="nextPeriod">next y</button> -->
                                    </div>
                                    <div id="calendar-month-text">{{ formattedDate }}</div> 
                                    <div id="calendar-period-select"> 
                                        <b-dropdown size="sm" variant="outline" style="width: 20%;">
                                            <template #button-content>
                                                Period  : {{ currentPeriodCountUoM }}
                                            </template>
                                            <b-dropdown-item @click="setPeriodCount(1)">
                                                <i class="fa-solid fa-calendar"></i> 1 
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="setPeriodCount(2)">
                                                 <i class="fa-solid fa-calendar-days"></i> 2  
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                    <div id="current-view-button">
                                        <b-dropdown id="dropdown-1" size="sm" variant="outline">
                                            <template #button-content>
                                                <i :class="currentViewIcon"></i> {{ currentViewText }}
                                            </template>
                                            <b-dropdown-item @click="switchView('month')">
                                                <i class="fa-regular fa-calendar-days"></i> Month 
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="switchView('week')">
                                                <i class="fa-solid fa-calendar-week"></i> Week  
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </template>                                
                        </calendar-view>
                    </b-tab>
            
                    <!-- task table view -->
                    <b-tab title="Tasks">
                        <div> 
                            <!-- loading spinner -->
                            <div v-if="loading" id="tasks-data-loading" style="text-align: center;">
                                <div class="lds-facebook"><div></div><div></div><div></div></div>
                                <div>Loading tasks...</div>
                            </div>
                            <!-- task table -->        
                            <div v-else id="content">
                                <br />
                                <!-- desktop table -->
                                <div id="table-desktop">
                                    <b-table class="tasks-table-desktop" hover head-variant="light" outlined responsive
                                        filterByFormatted="true"
                                        :total-rows="getfilteredItems().length"
                                        :items="getfilteredItems()"
                                        @change="getfilteredItems()"
                                        :fields="tasksTableFieldsDesktop"
                                        :filter="getfilteredItems()"
                                        @row-clicked="taskClicked" @filtered="filtering"
                                    >
                                        <template #cell(assigned_to)="data">
                                            <b-avatar v-if="data.value == undefined || !data.value" size="1.5rem" style="margin-right: 5px;"></b-avatar>
                                            <b-avatar v-else variant="success" size="1.5rem" :text="data.value.substring(0, 2).toUpperCase()" style="margin-right: 5px;"></b-avatar>
                                            {{ (data.value == undefined || !data.value ? 'Unassigned' : data.value) }}
                                        </template>
                                        <template #cell(status)="data">
                                            <b-badge :variant="getStatusVariantClass(data.value)">{{data.value}}</b-badge>
                                        </template>
                                        <template #cell(created_by)="data">
                                            <b-avatar variant="success" size="1.5rem" :text="data.value.substring(0, 2).toUpperCase()" style="margin-right: 5px;"></b-avatar> {{ data.value }}
                                        </template>
                                        <template #cell(name)="data">
                                            <span :class="{ 'strikethrough': data.item.status == 'Completed' }"> 
                                                <i v-if="data.item.status == 'Completed'" class="fa-regular fa-circle-check" style="margin-right: 5px;"></i>
                                                {{ data.value.substring(0, 20) + (data.value.length > 20 ? '...' : '') }}
                                            </span>
                                        </template>
                                        <template #cell(created_date)="data">
                                            {{ getFormattedDate(data.value) }}
                                        </template>
                                        <template #cell(start_date)="data">
                                            {{ data.item.start_date }}
                                        </template>
                                        <template #cell(end_date)="data">
                                            {{ data.item.end_date}}
                                        </template>
                                        <template #cell(equipment)="data">
                                            <span v-for="equipment in data.item.equipment" :key="equipment"  style="margin-right: 5px;">
                                                <kbd>{{ equipment }}</kbd>
                                            </span>
                                        </template>
                                        <template #cell(resource)="data">
                                            {{  data.item.resource  }} 
                                        </template>
                                        <template #cell(due_date)="data">
                                            {{ data.item.end_date ? getRelativeDate(data.item.end_date) : ' ' }}
                                        </template>
                                        <template #cell(Priority)="data">
                                            <b-badge :variant="getPrioritiesVariantClass(data.value)">{{data.value}}</b-badge>
                                        </template>
                                        <template #cell(task_category)="data">
                                            <i :class="getTaskCategoryIconClass(data.value)"></i> {{ data.value }}
                                        </template>
                                    </b-table>
                                </div>
                            
                                <!-- mobile table -->
                                <b-table id="tasks-table-mobile"  xl sticky-header borderless outlined hover
                                    style="min-width: 75%; padding-right: 10px; min-height: auto; max-height: 610px"
                                    responsive="sm"
                                    head-variant="light"
                                    filterByFormatted="true"
                                    :total-rows="getfilteredItems().length"
                                    :items="getfilteredItems()"
                                    :fields="tasksTableFieldsMobile"
                                    :filter="getfilteredItems()"
                                    @row-clicked="taskClicked">
                                    <template #cell(assigned_to)="data">
                                        <b-avatar v-if="data.value == undefined || !data.value" size="1.5rem" style="margin-right: 5px;"></b-avatar>
                                        <b-avatar v-else variant="success" size="1.5rem" :text="data.value.substring(0, 2).toUpperCase()" style="margin-right: 5px;"></b-avatar>
                                        {{ (data.value == undefined || !data.value ? 'Unassigned' : data.value) }}
                                    </template>
                                    <template #cell(status)="data">
                                        <b-badge :variant="getStatusVariantClass(data.value)">{{data.value}}</b-badge>
                                    </template>
                                    <template #cell(created_by)="data">
                                        <b-avatar variant="success" size="1.5rem" :text="data.value.substring(0, 2).toUpperCase()" style="margin-right: 5px;"></b-avatar> {{ data.value }}
                                    </template>
                                    <!-- <template #cell(task_description)="data">
                                        {{ data.value.substring(0, 100) + (data.value.length > 100 ? '...' : '') }}
                                    </template> -->
                                    <template #cell(created_date)="data">
                                        {{ getFormattedDate(data.value) }}
                                    </template>
                                    <template #cell(start_date)="data">
                                        {{ data.item.start_date }}
                                    </template>
                                    <template #cell(equipment)="data">
                                        <span v-for="equipment in data.item.equipment" :key="equipment"  style="margin-right: 5px;">
                                            <kbd>{{ equipment }}</kbd>
                                        </span>
                                    </template>
                                    <template #cell(resource)="data">
                                        {{ data.item.resource }}
                                    </template>
                                    <template #cell(end_date)="data">
                                        {{ data.item.end_date}}
                                    </template>
                                    <template #cell(due_date)="data">
                                        {{ data.item.end_date ? getRelativeDate(data.item.end_date) : ' ' }}
                                    </template>
                                    <template #cell(Priority)="data">
                                        <b-badge :variant="getPrioritiesVariantClass(data.value)">{{data.value}}</b-badge>
                                    </template>
                                    <template #cell(task_category)="data">
                                        <i :class="getTaskCategoryIconClass(data.value)"></i> {{ data.value }}
                                    </template>
                                </b-table>            
                            </div>
                            <!-- new task modal -->
                            <b-modal ref="new-task-modal" id="modal-new" scrollable title="New Task" size="xl" @hide="resetModal">
                                <div class="d-block" >    
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="* Name:" label-align="right" label-for="task-name-input">
                                            <b-form-input size="sm" id="task-name-input" v-model="newTask.name" :class="{ 'is-valid': newTask.name.length > 1, 'is-invalid': newTask.name.length <= 1 }" placeholder="Please enter Task name" trim/>
                                            <b-form-invalid-feedback id="task-name-input-feedback"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="* Location:"  label-align="right" label-for="task-location-input" @submit.stop.prevent>
                                            <label v-if="!newTask.location " for="task-location-input"></label>
                                            <b-form-select id="task-location-input" size="sm" v-model="newTask.location" :state="validation">
                                                <option value=""> -- Please select a location -- </option>
                                                <option v-for="option in huonLocationOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback :state="!validation"> </b-form-invalid-feedback>
                                            <b-form-valid-feedback :state="validation"> </b-form-valid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="* Category:" label-align="right" label-for="task-task_category-input">
                                            <b-form-select id="task-task_category-input" size="sm" v-model="newTask.task_category" :state="isvalidation">
                                                <option value=""> -- Please select a category -- </option>
                                                <option v-for="option in huonTaskCategoryOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                                            </b-form-select>
                                            <b-form-invalid-feedback :state="!isvalidation"> </b-form-invalid-feedback>
                                            <b-form-valid-feedback :state="isvalidation"> </b-form-valid-feedback>
                                        </b-form-group>
                                    </div>  
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Start Date:" label-align="right" label-for="task-start-input">
                                            <b-form-datepicker start-weekday="1" id="task-start-input" size="sm" v-model="newTask.start_date" ></b-form-datepicker>
                                        </b-form-group>  
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="End Date:" label-align="right" label-for="task-end-input">
                                            <b-form-datepicker start-weekday="1" id="task-end-input" size="sm" v-model="newTask.end_date" :min="newTask.start_date" @input="checkDateDifference"></b-form-datepicker>
                                        </b-form-group>  
                                    </div>
                                    <div class="content-row" v-if="showRepeatInput">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Repeated for: " label-align="right">
                                            <div class="d-flex align-items-center">
                                                <b-form-input id="task-repeat" type="number" size="sm" v-model="newTask.repeat" style="max-width: 60px;" :min="1" :max="5"></b-form-input>
                                                <span class="ml-2">weeks</span>
                                            </div>
                                        </b-form-group>  
                                    </div>
                                    <!-- <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Name:" label-align="right" label-for="task-name-input">
                                        <b-form-input id="task-name-input" size="sm" v-model="newTask.name" placeholder="Enter a name for the task..."></b-form-input>
                                    </b-form-group> -->


                                    <!-- <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Location:" label-align="right" label-for="task-location-input">
                                        <b-form-select id="task-location-input" size="sm" v-model="newTask.location" :options="huonLocationOptions"></b-form-select>
                                    </b-form-group> -->
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Status:" label-align="right" label-for="task-status-input">
                                            <b-form-select id="task-status-input" size="sm" v-model="newTask.status" :options="visibleTaskStatusOptions()"></b-form-select>
                                            <b-badge :variant="getStatusVariantClass(newTask.status)">{{ newTask.status }}</b-badge>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Assigned To:" label-align="right" label-for="task-assigned_to-input">
                                            <b-form-select id="task-assigned_to-input" size="sm" v-model="newTask.assigned_to" :options="huonTasksPeopleOptions"></b-form-select>
                                            <b-avatar variant="success" size="1.5rem" :text="(newTask.assigned_to == undefined ? '' : newTask.assigned_to.substring(0, 2).toUpperCase())" style="margin-right: 5px;"></b-avatar> <u>{{ newTask.assigned_to }}</u>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="equipment :" label-align="right" label-for="task-equipment-input">
                                            <b-form-tags id="tags-with-dropdown" v-model="newTask.equipment" no-outer-focus> 
                                                <template v-slot="{ tags, disabled, addTag, removeTag }">
                                                    <ul v-if="tags.length > 0" class="list-inline">
                                                        <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                                            <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="info" style="line-height: 20px"> {{ tag }} </b-form-tag>
                                                        </li>
                                                    </ul>
                                                    <div class="d-flex align-items-center">
                                                        <b-form-input v-model="searchEquipment" id="tag-search-input" type="search" size="sm" autocomplete="off" @input="handleEquipmentSearchInput" placeholder="Search equipment..." class="ml-2" style="max-width: 50% "></b-form-input>
                                                        <div style="font-size: 13px; margin-left: 10px"> Qty </div>
                                                        <b-form-input v-model="equipmentQuantity" type="number" size="sm" style="max-width: 70px; margin-left: 20px;" min="1" placeholder="Qty"></b-form-input>
                                                        <b-button size="sm" style="margin-left:30px" variant="primary" @click="addEquipmentTag({ equipment: searchEquipment, addTag })" :disabled="!isEquipmentSelected"> Add </b-button>
                                                    </div>
                                                    <div class="dropdown-container">
                                                        <b-list-group v-if="searchEquipmentDropDownVisible" class="dropdown-list" style="z-index: 1000;">
                                                            <b-list-group-item v-for="option in filteredEquipmentOptions" :key="option" @click="onEquipmentOptionClick(option)" style="cursor: pointer;">
                                                                {{ option }}
                                                            </b-list-group-item>
                                                            <b-list-group-item v-if="filteredEquipmentOptions.length === 0">
                                                                There are no Equipment available to select for "<strong>{{searchEquipment}}</strong>". 
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </template>
                                            </b-form-tags>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="No. of Resources:" label-align="right" label-for="task-resource-input">
                                            <b-form-input type="number" size="sm" id="task-resource-input" v-model="newTask.resource" placeholder="Enter a number" trim/>
                                        </b-form-group>
                                    </div> 
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Priority:" label-align="right" label-for="task-priority-input">
                                            <b-form-select v-model="newTask.Priority" size="sm"  >
                                                <option v-for="option in priorities" :key="option.value" :value="option.value">{{ option.label }}</option>
                                            </b-form-select>
                                            <b-badge :variant="getPrioritiesVariantClass(newTask.Priority)">{{ newTask.Priority}}</b-badge>
                                        </b-form-group>
                                    </div>  
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Details:" label-align="right" label-for="task-description-input">
                                            <vue-editor v-model="newTask.task_description"></vue-editor>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Created:" label-align="right" label-for="task-created-input">
                                            <b-form-input id="task-created-input" size="sm" v-model="newTask.created_date" disabled></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Created By:" label-align="right" label-for="task-created_by-input">
                                            <b-avatar variant="success" size="1.5rem" :text="(newTask.created_by ? newTask.created_by.substring(0, 2).toUpperCase() : '')" style="margin-right: 5px;"></b-avatar> <u>{{ newTask.created_by }}</u>
                                            <b-form-input id="task-created_by-input" size="sm" v-model="newTask.created_by" disabled style="display: none;"></b-form-input>
                                        </b-form-group>
                                    </div>  
                                </div>
                                <template #modal-footer="{}">
                                    <b-button variant="secondary" size="sm" @click="$refs['new-task-modal'].hide()" style="position: relative; float: right;"><i class="fa-solid fa-xmark"></i><span style="padding-left: 10px;">Close</span></b-button>                                        
                                    <b-button variant="primary" size="sm"  @click="createAndRepeatTask(newTask)" style="position: relative; float: right;" :disabled="savingTask || newTask.name.length <=1 || !validation || !isvalidation"><i v-if="!savingTask" class="fa-solid fa-check"></i><i v-else class="fa-solid fa-circle-notch fa-spin"></i><span style="padding-left: 10px;">{{(savingTask ? 'Saving' : 'Save')}} </span></b-button>                        
                                </template>                        
                            </b-modal>

                            <!-- edit task modal -->
                            <b-modal ref="task-details-modal"  id="modal-edit" scrollable :title="'Task - ' + selectedTask.name" size="xl" >
                                <div class="d-block" style="padding-bottom: 15px;">
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Name:" label-align="right" label-for="task-name-input" >
                                            <b-form-input id="task-name-input" size="sm" v-model="selectedTask.name" placeholder="Enter a name for the task..."></b-form-input>
                                        </b-form-group>
                                    </div>
                                     <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Location:" label-align="right" label-for="task-location-input">
                                            <b-form-select id="task-location-input" size="sm" v-model="selectedTask.location" :disabled="!isEditAllowed()">
                                                <option v-for="option in huonLocationOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Category:" label-align="right" label-for="task-task_category-input">
                                            <b-form-select id="task-task_category-input" size="sm" v-model="selectedTask.task_category" :disabled="!isEditAllowed()">
                                                <option v-for="option in huonTaskCategoryOptions" :key="option.value" :value="option.value">{{ option.label }} </option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>  
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Start Date:" label-align="right" label-for="task-start-input">
                                            <b-form-datepicker start-weekday="1" id="task-start-input" size="sm" v-model="selectedTask.start_date" :disabled="!isEditAllowed()"></b-form-datepicker>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="End Date:" label-align="right" label-for="task-end-input">
                                            <b-form-datepicker start-weekday="1" id="task-end-input"  :state="getEndDateState()" size="sm" v-model="selectedTask.end_date" :min="selectedTask.start_date"></b-form-datepicker>
                                        </b-form-group>  
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Status:" label-align="right" label-for="task-status-input">
                                            <b-form-select id="task-status-input" size="sm" v-model="selectedTask.status" :options="visibleTaskStatusOptions()" :disabled="!isEditAllowed()"></b-form-select>
                                            <b-badge :variant="getStatusVariantClass(selectedTask.status)">{{ selectedTask.status }}</b-badge>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Assigned To:" label-align="right" label-for="task-assigned_to-input">
                                            <b-form-select id="task-assigned_to-input" size="sm" v-model="selectedTask.assigned_to" :options="huonTasksPeopleOptions" :disabled="!isEditAllowed()"></b-form-select>
                                            <b-avatar variant="success" size="1.5rem" :text="(selectedTask.assigned_to == undefined ? '' : selectedTask.assigned_to.substring(0, 2).toUpperCase())" style="margin-right: 5px;"></b-avatar> <u>{{ selectedTask.assigned_to }}</u>
                                        </b-form-group>
                                    </div>
                                    <!-- <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="equipment :" label-align="right" label-for="task-equipment-input">
                                            <b-form-tags tag-pills tag-variant="primary" size="sm" id="task-equipment-input" v-model="selectedTask.equipment" placeholder="Tags"  />
                                        </b-form-group>
                                    </div>   -->
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="equipment :" label-align="right" label-for="task-equipment-input">
                                            <b-form-tags id="tags-with-dropdown" v-model="selectedTask.equipment" no-outer-focus> 
                                                <template v-slot="{ tags, disabled, addTag, removeTag }">
                                                    <ul v-if="tags.length > 0" class="list-inline">
                                                        <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                                            <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="info" style="line-height: 20px"> {{ tag }} </b-form-tag>
                                                        </li>
                                                    </ul>
                                                    <div class="d-flex align-items-center">
                                                        <b-form-input v-model="searchEquipment" id="tag-search-input" type="search" size="sm" autocomplete="off" @input="handleEquipmentSearchInput" placeholder="Search equipment..." class="ml-2" style="max-width: 50% "></b-form-input>
                                                        <div style="font-size: 13px; margin-left: 10px"> Qty </div>
                                                        <b-form-input v-model="equipmentQuantity" type="number" size="sm" style="max-width: 70px; margin-left: 20px;" min="1" placeholder="Qty"></b-form-input>
                                                        <b-button size="sm" style="margin-left:30px" variant="primary" @click="addEquipmentTag({ equipment: searchEquipment, addTag })" :disabled="!isEquipmentSelected"> Add </b-button>
                                                    </div>
                                                    <div class="dropdown-container">
                                                        <b-list-group v-if="searchEquipmentDropDownVisible" class="dropdown-list" style="z-index: 1000;">
                                                            <b-list-group-item v-for="option in filteredEquipmentOptions" :key="option" @click="onEquipmentOptionClick(option)" style="cursor: pointer;">
                                                                {{ option }}
                                                            </b-list-group-item>
                                                            <b-list-group-item v-if="filteredEquipmentOptions.length === 0">
                                                               No equipment found for "<strong>{{searchEquipment}}</strong>". 
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </template>
                                            </b-form-tags>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="No. of Resources:" label-align="right" label-for="task-resource-input">
                                            <b-form-input type="number" size="sm" id="task-resource-input" v-model="selectedTask.resource" trim/>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Priority" label-align="right" label-for="task-priority-input">
                                            <b-form-select v-model="selectedTask.Priority" size="sm" :disabled="!isEditAllowed()">
                                                <option v-for="option in priorities" :key="option.value" :value="option.value">{{ option.label }}</option>
                                            </b-form-select>
                                            <b-badge :variant="getPrioritiesVariantClass(selectedTask.Priority)">{{ selectedTask.Priority }}</b-badge>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Details:" label-align="right" label-for="task-description-input">
                                            <vue-editor v-model="selectedTask.task_description" :disabled="!isEditAllowed()"></vue-editor>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Created:" label-align="right" label-for="task-created-input">
                                            <b-form-input id="task-created-input" size="sm" v-model="selectedTask.created_date" disabled></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="content-row">
                                        <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Created By:" label-align="right" label-for="task-created_by-input">
                                            <b-avatar variant="success" size="1.5rem" :text="selectedTask.created_by.substring(0, 2).toUpperCase()" style="margin-right: 5px;"></b-avatar> <u>{{ selectedTask.created_by }}</u>
                                            <b-form-input id="task-created_by-input" size="sm" v-model="selectedTask.created_by" disabled style="display: none;"></b-form-input>
                                        </b-form-group>
                                    </div>
                                </div>
                                <template #modal-footer="{}">
                                    <b-button variant="secondary" size="sm" @click="$refs['task-details-modal'].hide()" style="position: relative; float: right;"><i class="fa-solid fa-xmark"></i><span style="padding-left: 10px;">Close</span></b-button>
                                    <b-button v-b-modal.modal-center variant="danger" size="sm" :disabled="!isEditAllowed()"> <i class="fa-solid fa-trash"></i> Cancel </b-button>
                                    <b-modal ref="confirmationModal" id="modal-center" size="sm" centered title="Cancel Task">
                                        Are you sure you want to <strong>Cancel</strong> this task?<br/><br/><strong>{{ selectedTask.name }}</strong>
                                        <template #modal-footer="{}">
                                            <b-button size="sm" variant="secondary" @click="$refs.confirmationModal.hide()">
                                                No
                                            </b-button>                    
                                            <b-button size="sm" variant="danger" @click="cancelTask(selectedTask)">
                                                Yes
                                            </b-button>
                                        </template>                              
                                    </b-modal>
                                    <b-button variant="primary" size="sm" @click="saveSelectedTask(selectedTask)" style="position: relative; float: right;" :disabled="savingTask || !isEditAllowed() || !getEndDateState()"><i v-if="!savingTask" class="fa-solid fa-check"></i><i v-else class="fa-solid fa-circle-notch fa-spin"></i><span style="padding-left: 10px;">{{(savingTask ? 'Updating' : 'Update')}}</span></b-button>                        
                                </template>     
                            </b-modal>
                        </div>
                    </b-tab>
                    <b-tab title="Equipment">
                        <div>
                            <b-button :disabled="hasEquipmentsItemsInEdit || !isEditAllowed()" size="sm" style="margin-bottom: 10px; margin-top: 5px" variant="primary" @click="insertEquipment">
                                <i class="fa-solid fa-plus"></i>  Add 
                            </b-button>
                            <div id="equipment-table">
                                <b-table bordered hover head-variant="light" outlined responsive :items="equipmentTableData" :fields="equipmentTable" >
                                    <template #cell(Name)="data">
                                       <span :class="{ 'strikethrough': data.item.active == false }">   
                                            <b-form-input v-if="data.item.inEdit" v-model="data.item.Name" placeholder="Enter Name"/> <span v-else>{{ data.item.Name }}</span> 
                                        </span>
                                    </template>
                                    <template #cell(Units)="data">
                                            <b-form-input v-if="data.item.inEdit" type="number" v-model="data.item.Units" min="1" placeholder="Enter Units"/> <span v-else>{{ data.item.Units }}</span>
                                    </template>
                                    <template #cell(Location)="data">
                                        <b-form-select v-if="data.item.inEdit" id="task-location-input" v-model="data.item.Location" :disabled="!isEquipmentEditAllowed()">
                                            <option v-for="option in huonLocationOptions" :key="option.value" :value="option.value"> {{ option.value }} </option> 
                                        </b-form-select> 
                                        <span v-else>{{ data.item.Location }}</span>
                                    </template>
                                    <template #cell(edit)="data">
                                        <div v-if="data.item.isNew" >
                                            <b-button size="sm" style="margin-left: 10px;  margin-top: 3px" :disabled="!data.item.Name" variant="primary" @click="saveNewEquipment(data.item)"><i class="fa-solid fa-check"></i> <span style="margin-right: 6px;"> </span> Save</b-button>
                                            <b-button size="sm" style="margin-left: 10px; margin-top: 3px"  @click="discardEquipment(data.item)"><i class="fa-solid fa-xmark"></i> <span style="margin-right: 6px;"></span>Discard</b-button>
                                        </div>
                                        <div v-else-if="data.item.inEdit" >
                                            <b-button size="sm" style="margin-left: 10px; margin-top: 3px" variant="primary" @click="updateEquipment(data.item)"><i class="fa-regular fa-floppy-disk"></i> <span style="margin-right: 6px;"> </span> Update</b-button>
                                            <b-button size="sm" style="margin-left: 10px; margin-top: 3px"  @click="cancelEquipmentEdit(data.item)"><i class="fa-solid fa-ban"></i> <span style="margin-right: 6px;"> </span> Cancel</b-button>
                                        </div>
                                        <div v-else style="display: flex; align-items: center;">
                                            <b-button size="sm" style="margin-left: 10px;" variant="primary" @click="editEquipment(data.item)" :disabled="!isEditAllowed()"> <i class="fa-solid fa-pen-to-square"></i> <span style="margin-right: 6px;"> </span> Edit</b-button>
                                            <b-form-checkbox switch size="sm"  style="margin-right: -80px; margin-left: 20px" @change="toggleEquipmentActiveStatus(data.item)" :value="true" :checked="data.item.active" button-variant="info">
                                                <span :class=" data.item.active ? 'switchGreen' : 'switchRed'">{{ data.item.active ?  'Active'  : 'Inactive' }}</span>
                                            </b-form-checkbox>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                            <div v-if="equipmentTableData.length === 0"> There is no data available </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-col>
        </div>
        <!-- Modal to show when you drag and drop a task in calendar -->
        <b-modal ref="move-confirm-modal" modal-center centered title="Confirmation">
           Would you like to move or copy the task -  <strong>{{ selectedTask.name }}</strong> to <strong>{{ newDate }}  ?</strong> 
            <template #modal-footer="{}">
                <b-button size="sm" variant="secondary" @click="$refs['move-confirm-modal'].hide()"><i class="fa-solid fa-xmark"></i><span style="padding-left: 10px;">Close</span></b-button>     
                <b-button size="sm" variant="primary" @click="copyTask(selectedTask)"><i class="fa-solid fa-copy"></i><span style="padding-left: 10px;"> Copy </span> </b-button>       
                <b-button size="sm" variant="primary" @click="saveTaskDetails(selectedTask)"><i class="fa-solid fa-up-down-left-right"></i><span style="padding-left: 10px;"> Move </span> </b-button>
            </template>            
        </b-modal>
        <b-modal ref="errorModal" modal-center centered title="Error !">
            You do not have permission edit tasks ! 
            <template #modal-footer="{}">      
                <b-button size="sm" variant="secondary" @click="$refs['errorModal'].hide()"> OK </b-button> 
            </template>                  
        </b-modal>
        <b-modal ref="colour" size="md" centered title="Pick colours for Locations" >       
            <div v-for="option in huonLocationOptions" :key="option.value" :value="option.value" style="margin-bottom: 10px;">
                <div class="category-item">
                    <b-row> 
                        <b-col cols="5" class="d-flex align-items-center" style="margin-left: 10px">
                            <span class="location-background-preview" :style="{ backgroundColor: option.class  }" style="z-index: 1;" ></span> 
                            <span class="category-label" :style="{ color: getPreviewText(option) }" style="z-index: 2; margin-left: 2px"  >{{ option.label }}   </span>
                        </b-col>
                        <b-col cols="2" class="d-flex justify-content-end">
                            <b-dropdown class="custom-dropdown" size="sm" dropright style="min-width: 40px; margin-right: 25px; " variant="link">
                                <chrome-picker v-model="option.class" @input="updateAllColours(option)" /> 
                            </b-dropdown>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <template #modal-footer="{}">   
                <b-button variant="primary" size="sm"  @click="$refs['colour'].hide()" style="position: relative; float: right;"> <i class="fa-solid fa-check"> </i> Done</b-button>                        
            </template>      
        </b-modal> 
    </div>
</template>

<script>
    import moment from 'moment';
    import { VueEditor } from "vue2-editor";
    import UserInfoStore from '../../app/user-info-store';
    import { Chrome } from 'vue-color';
    
    // reference https://www.npmjs.com/package/vue-simple-calendar/v/5.0.0?activeTab=readme#props
        
    import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
    require("vue-simple-calendar/static/css/default.css")
    // require("vue-simple-calendar/static/css/holidays-us.css")

    export default {
        name: "TasksContent",
        components: {
                VueEditor,
                CalendarView,
                CalendarViewHeader,
                'chrome-picker': Chrome,
        },
        props: {
            site: [],
            showLocationFilters: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                loading: true,
                stickyHeader: true,
                currentView: 'month',
                savingTask: false,
                deletingTask: false,
                today: '',
                current_user: '',
                userInfo: [],
                sites: [],
                selectedLocations: [],
                filter: '',
                newDate: '',
                currentPage: 1,
                perPage: 10,
                tasksTableFieldsDesktop: [
                    // { key: 'id', label: '#', stickyColumn: true, sortable: true, },
                    { key: 'name', label: 'Task', stickyColumn: true, sortable: true, },
                    // { key: 'task_description', label: 'Task Description', stickyColumn: false, sortable: true, },
                    { key: 'location', label: 'Location', stickyColumn: true, sortable: true, },
                    // { key: 'created_date', label: 'Created', stickyColumn: false, sortable: true, }, 
                    // { key: 'created_by', label: 'Created By', stickyColumn: false, sortable: true, },
                    { key: 'assigned_to', label: 'Assigned To', stickyColumn: true, sortable: true, },
                    { key: 'resource', label: 'Resources', stickyColumn: true, sortable: true, },
                    {key: 'equipment', label: 'Equipment', stickyColumn: true, sortable: true, },
                    { key: 'Priority', label: 'Priority', stickyColumn: true, sortable: true, },
                    { key: 'start_date', label: 'Start date', stickyColumn: true, sortable: true, },
                    { key: 'end_date', label: 'End date', stickyColumn: true, sortable: true, },
                    // { key: 'due_date', label: 'Due', stickyColumn: false, sortable: true, },
                    { key: 'status', label: 'Status', stickyColumn: true, sortable: true, },
                    { key: 'task_category', label: 'Category', stickyColumn: true, sortable: true, },
                ],
                tasksTableFieldsMobile: [
                    // { key: 'id', label: '#', stickyColumn: true, sortable: true, },
                    { key: 'name', label: 'Task', sortable: true, },
                    // { key: 'task_description', label: 'Task Description', stickyColumn: false, sortable: true, },
                    { key: 'location', label: 'Location',  sortable: true, },
                    // { key: 'created_date', label: 'Created', stickyColumn: false, sortable: true, },
                    // { key: 'created_by', label: 'Created By', stickyColumn: false, sortable: true, },
                    // { key: 'assigned_to', label: 'Assigned To', stickyColumn: false, sortable: true, },
                    // { key: 'due_date', label: 'Due', stickyColumn: false, sortable: true, },
                    { key: 'status', label: 'Status',  sortable: true, },
                    { key: 'task_category', label: 'Category',  sortable: true, },
                ],                
                tasks: [],
                taskStatusOptions: [
                    'New', 
                    'In progress', 
                    'Testing', 
                    'On Hold', 
                    'Completed', 
                    'Canceled'
                ],
                priorities: [
                    { value: 'Highest', label: 'Highest' },
                    { value: 'High', label: 'High' },
                    { value: 'Medium', label: 'Medium' },
                    { value: 'Low', label: 'Low' },
                    { value: 'Lowest', label: 'Lowest' },
                ],
                huonLocationOptions: [],
                huonTaskCategoryOptions: [
                    {value: 'Uncategorised', label: 'Uncategorised'} ,
                    {value: 'Fertilisation', label: 'Fertilisation'} ,
                    {value: 'Maintenance', label: 'Maintenance'} ,
                    {value: 'Spawning', label: 'Spawning'} ,
                    {value: 'Brood tagging', label: 'Brood tagging'} ,
                    {value: 'Brood sorting', label: 'Brood sorting'} ,
                    {value: 'IP vaccination', label: 'IP vaccination'} ,
                    {value: 'Dip vaccination', label: 'Dip vaccination'} ,
                    {value: 'Marine Transfer', label: 'Marine Transfer'} ,
                    {value: 'Hatchery Transfer', label: 'Hatchery Transfer'} ,
                    {value: 'Grading', label: 'Grading'} ,
                    {value: 'SBP measure / Bath', label: 'SBP measure / Bath'} ,
                    {value: 'Trials Bathing', label: 'Trials Bathing'} ,
                    {value: 'Trials Stocking', label: 'Trials Stocking'} ,
                    {value: 'Trial Harvest', label: 'Trial Harvest'} ,
                ],
                huonTasksPeopleOptions: [/*
                    {
                        text: 'Borhan Zadeh', 
                        value: 'bzadeh@vitrafy.com'
                    }, 
                    {
                        text: 'Jarrod Wells', 
                        value: 'jwells@huonaqua.com.au'
                    }, 
                    { 
                        text: 'Simon Pitney', 
                        value: 'spitney@huonaqua.com.au'
                    }, 
                    {
                        text: 'Jennifer Cook', 
                        value: 'jcook@vitrafy.com'
                    }
                */],
                newTask: { 
                    id: '', 
                    name: '', 
                    task_description: '', 
                    location: '', 
                    created_date: '', 
                    created_by: '', 
                    assigned_to: '',
                    start_date: '', 
                    end_date: '', 
                    repeat: '1',
                    due_date: '', 
                    Priority: 'Medium', 
                    status: 'New', 
                    task_category: '', 
                    resource: '',
                    equipment: [],
                },
                selectedTask: { 
                    id: '',
                    name: '',
                    task_description: '',
                    location: '',
                    created_date: '',
                    created_by: '',
                    assigned_to: '',
                    start_date: '',
                    end_date: '',
                    due_date: '',
                    Priority: '',
                    status: '',
                    task_category: '',
                    resource: '',
                    equipment: [],
                },
                selectedDate: '',
                currentDate: new Date().toISOString().substr(0, 10), // Initialize with today's date in 'YYYY-MM-DD' format
                selected: [],  
                allSelected: false,
                allCategoriesSelected: false,
                Categoryselected: [],
                text: "vue-simple-calendar v5.0.0",
                showDate: new Date(),
                enableDragDrop: true,
                items: [],
                windowWidth: window.innerWidth,
                ScreenWidthState: false,      
                colors: [], 
                RepeatweekNumber: 1,
                showRepeatInput: true,
                showCompletedTasks: false,
                displayPeriodCount: 1,
                options: [], 
                searchEquipment: '', 
                searchEquipmentDropDownVisible: false, 
                equipmentQuantity: 1,
                newTags: [],
                equipmentOptions: [],
                filteredEquipmentOptions: [],
                equipment: [],
                equipmentTableData: [],      
                originalData: [],  // This will keep the original data so users can discard changes in equipment table 
                hasEquipmentsItemsInEdit: false,
                equipmentTable: [
                    { key: 'Name', label: 'Name', stickyColumn: true, sortable: true },
                    { key: 'Units', label: 'Units', stickyColumn: true, sortable: true },
                    { key: 'Location', label: 'Location',  stickyColumn: true, sortable: true },
                    { key: 'edit', label: '', descendent: true, stickyColumn: true, sortable: true },
                ],

            };
        },
        mounted: async function () {
            this.showVitrafyLogo(false);
            this.showVitrafyLock(false);
            this.TasksPaddingRemove(false);
            this.TaskGridRemove(false);
            await this.getTasksFromDB();
            this.getfilteredItems();
            await this.getSitesFromDynamo();
            this.sites.forEach(site => {
                //console.log("siteSSSSSS:", this.sites)
                this.huonLocationOptions.push({label: site.id, value: site.id, class: site.calendar_category_colour, EventColourClass: site.EventColourClass})
            });

            this.huonTasksPeopleOptions = await this.getHuonTaskUsers();

            //console.log("List built: ", this.huonLocationOptions)
            // TODO: find a better way to find the correct parent
            this.userInfo = UserInfoStore.state.cognitoInfo;
            this.userName = this.userInfo.username;

            //console.log("Username: ", this.current_user)
            //console.log("this is the site that passed in ", this.site)
            // console.log("User info: ", UserInfoStore)
            this.today = moment(new Date(new Date())).format('YYYY-MM-DD')
            await setTimeout(() => { // Make it looks like the table is loading
                this.getTasksFromDB();
            }, 500)     
            await this.getHuonEquipmentFromAPI();
            this.selectedDate = new Date();
            const storedSelected = localStorage.getItem('selected');
            const storedAllSelected = localStorage.getItem('allSelected');
            const storedCategoryselected = localStorage.getItem('Categoryselected');
            const storedallCategoriesSelected = localStorage.getItem ('allCategoriesSelected');
            if (storedSelected) this.selected = JSON.parse(storedSelected);
            else this.selected = this.huonLocationOptions.map(option => option.value);
            if (storedCategoryselected) this.Categoryselected = JSON.parse(storedCategoryselected);
            else this.Categoryselected = this.huonTaskCategoryOptions.map(option => option.value);
            this.allSelected = storedAllSelected === 'true';
            this.allCategoriesSelected = storedallCategoriesSelected === 'true';
            this.updateCalendarItems();
            this.colors = this.huonLocationOptions.map(option => option.class);    
            this.equipment.forEach(equipment => {
                const item = { 
                    id: equipment.id,
                    Name: equipment.name, 
                    Units: equipment.units, 
                    Location: equipment.location, 
                    active: equipment.active,
                    inEdit: false, 
                    isNew: false 
                };
                this.equipmentTableData.push(item);
            });
        },
        computed:{
            validation() {
                return this.newTask.location!== '';
            },
            isvalidation(){
                return this.newTask.task_category!== '';
            },
            buttonSize() {
                return this.windowWidth < 767 ? 'sm' : '';
            },      
            formattedDate() {
                const months = [
                    "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];

                const monthName = months[this.showDate.getMonth()];
                const year = this.showDate.getFullYear();

                return `${monthName} ${year}`;
            },
            currentViewText() {
                return this.currentView === 'month' ? 'Month' : 'Week';
            },
            currentPeriodCountUoM() {
                return this.displayPeriodCount === 1 ? '1' : '2';
            },
            currentViewIcon() {
                return this.currentView === 'month' ? 'fa-regular fa-calendar-days' : 'fa-solid fa-calendar-week';
            },
            displayview() {
                return this.currentView === 'month' ? 'month' : 'week';
            },
            weekViewItemHeight() {
                if(this.currentView === 'week') {
                    return '100px';
                }
                else {
                    return '22px';
                }
            },
            weekViewitemTop () {
                if(this.currentView) {
                    return '2em';
                }
                else {
                    return '2em';
                }
            },
            filteredTasks() {
                if (this.showCompletedTasks) {
                    return this.tasks;
                } 
                else {
                    return this.tasks.filter(task => task.status !== 'Completed');
                }
            },
            criteria() {
                return (this.searchEquipment || '').trim().toLowerCase();
            },
            getfilteredEquipmentOptions() {
                const criteria = this.criteria;
                const Allequipment = this.equipment;
                const equipmentNames = Allequipment.filter(option => option.active !== false).map(option => option.name);
                const allOptions = (equipmentNames || []).filter(opt => 
                    typeof opt === 'string' && !this.newTask.equipment.includes(opt)
                );
                const uniqueOptions = [...new Set(allOptions)];

                if (criteria) {
                    return uniqueOptions.filter(opt => opt.toLowerCase().includes(criteria));
                }
                
                return uniqueOptions;
            },
            isEquipmentSelected() {
                return this.filteredEquipmentOptions.includes(this.searchEquipment);
            },
        },
        created() {
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy(){
            this.showVitrafyLogo(true);
            this.showVitrafyLock(true);
            this.TasksPaddingRemove(true);
            this.TaskGridRemove(true);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },  
        methods: {
            handlePreviousYearClick () {
                // calendar
                this.showDate = new Date(this.showDate.setFullYear(this.showDate.getFullYear() - 1));
                // mini cal
                let date = new Date(this.selectedDate);
                date.setFullYear(date.getFullYear() - 1);
                this.selectedDate = date.toISOString().substr(0, 10);              
            },
            handlePreviousPeriodClick() {
				if (this.currentView === 'month') {
                    this.showDate.setMonth(this.showDate.getMonth() - 1);
                    this.selectedDate = this.showDate;
                } 
				else {
                    this.showDate.setDate(this.showDate.getDate() - 7);
                    this.selectedDate = this.showDate;
                }
                    this.showDate = new Date(this.showDate); 
                    this.selectedDate = this.showDate;
            },
            handleTodayClick() {
                // calendar
                this.showDate = new Date();
                // mini cal
                this.selectedDate = new Date();
            },
            handleNextPeriodClick() {
                if (this.currentView === 'month') {
                    this.showDate.setMonth(this.showDate.getMonth() + 1);
                    this.selectedDate = this.showDate;
                } 
				else {
                    this.showDate.setDate(this.showDate.getDate() + 7);
                    this.selectedDate = this.showDate;
                }
                    this.showDate = new Date(this.showDate); 
                    this.selectedDate = this.showDate;
            },
            handleNextYearClick () {
                // calendar
                this.showDate = new Date(this.showDate.setFullYear(this.showDate.getFullYear() + 1));
                // mini cal
                let date = new Date(this.selectedDate);
                date.setFullYear(date.getFullYear() + 1);
                this.selectedDate = date.toISOString().substr(0, 10);                  
            },            
            dateInfoFn(date) {
                const today = new Date().toISOString().substr(0, 10);
                if (date === today) {
                    return { highlight: true, contentClass: 'text-info' };
                }
                return {};
            },
            async getHuonTaskUsers(){
                let usersList = [];
                try {
                    let response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                        { "TableName": "lifechain-users" },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );

                    if (response.data) usersList = response.data;
                } 
				catch (error) {
                    console.log(error);
                }

                return usersList.filter(user => user.huon_user).map(user => {
                    return {
                        text: user.id,
                        value: user.id
                    }
                });
            },
            getPreviewText(option) {
                const color = this.huonLocationOptions.find(site => site.value == option.label).class || '#FFFFFF';
                const fontColor = this.isDarkColor(color) ? '#ffffff' : '#000000';
                return fontColor;
            },
            getItemTitle(task) {

                const statusIcon = task.status == 'Completed' ? '<i class="fa-regular fa-circle-check"></i>' : '';
                const nameClass = task.status == 'Completed' ? 'strikethrough' : '';
                const name = task.name;
                const resource = task.resource ? task.resource : '0';
                const location = task.location ? task.location : '-';
                const category = task.task_category ? task.task_category : '-';
                const equipment = task.equipment != undefined && task.equipment.length > 0 ? task.equipment.map(item => `<kbd>${item}</kbd>`).join(' ') : '<kbd>None</kbd>';
                const color = this.huonLocationOptions.find(site => site.value == task.location).class || '#FFFFFF';
                const fontColor = this.isDarkColor(color) ? '#ffffff' : '#000000';

                return this.currentView == 'month'
                    ? `<span style="color: ${fontColor};">${statusIcon}</span>
                    <span class="${nameClass}" style="color: ${fontColor};">${name} - ${resource}</span>`
                    : `<span  style="color: ${fontColor};">${statusIcon}</span>
                    <span style="color: ${fontColor};"><strong style="color: ${fontColor};">Category:</strong> ${category}</span><br>
                    <span class="${nameClass}" style="color: ${fontColor};"><span><strong style="color: ${fontColor};">Name: </strong></span> ${name}</span><br>
                    <span style="color: ${fontColor};"><strong style="color: ${fontColor};">Resources:</strong> ${resource}</span><br>
                    <span style="color: ${fontColor};"><strong style="color: ${fontColor};">Location:</strong> ${location}</span><br>
                    <span style="color: ${fontColor}; display: inline-block; margin-top: 5px;"><strong style="color: ${fontColor};">Equipment :</strong> ${equipment} </span><br>`;                  
            },   
            async getTasksFromDB() {
                this.loading = true;   
                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_TASKS_API_URI + "/items",
                        JSON.stringify({}),
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    this.tasks = response.data;
                    this.items = []; 

                    this.getfilteredItems()
                        .forEach(task => { 
                            const color = this.huonLocationOptions.find(site => site.value == task.location).class || '#FFFFFF';

                            this.items.push({                              
                                id: task.id,
                                title: this.getItemTitle(task, this.equipment) ,
                                startDate: task.start_date,
                                endDate: task.end_date,  
                                style: `background-color: ${color}` 
                            });
                        });                                  
                        // console.log("this is the items", this.items)
                } 
				catch (error) {
                    console.log(error);
                }
                this.loading = false;
            },
            async getFilteredTiles() {
                if (!this.userInfo.user_additional_info) 
					return [];
                else {
                    if (this.userInfo.user_additional_info.admin_user || (this.userInfo.user_additional_info.huon_user && this.userInfo.user_additional_info.user_level.includes("manager"))) 
						return this.tiles;
                    else {
                        var filteredTiles = [];
                        this.tiles.forEach(tile => {
                            tile.permissions.forEach(permission => {
                                if (
                                    this.userInfo.user_additional_info.user_level.includes(permission) && // <-- Permissiosn matches the user's permission levels
                                    filteredTiles.indexOf(tile) == -1 // <-- Tile isn't already on the list
                                ) 
									filteredTiles.push(tile) // <-- Add the tile to the list
                            });
                        });
                        return filteredTiles;
                    }
                }
            },
            async saveEquipmentDetails(item) {
                 try {
                            this.$http.put(
                                process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                                { "TableName": "aquaculture_equipment", "Item" : item },
                                { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                            );       
                            await this.getHuonEquipmentFromAPI();           
                        }             
                        catch (error) {
                            console.log(error);
                        }              
                    //   console.log('Equipment Details After:', Item);    
                },
            async getHuonEquipmentFromAPI() {
                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                        { "TableName": "aquaculture_equipment" },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                const data = response.data;
                this.equipment = data;
                this.equipmentOptions = data.map(equipment => equipment.name);
                // console.log('equipment loaded:2', this.equipment);
                // console.log('Data loaded:', data);
                }
                catch (error) {
                    console.log(error);
                }              
            },
            async getSitesFromDynamo() {
                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                        { "TableName": "aquaculture_sites" },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    this.sites = response.data;
                } 
				catch (error) {
                    console.log(error);
                }
            },
            async saveTaskDetails(task) {
                this.savingTask = true;
                this.loading = true;
                 //(this.tasks.length + 1); // Set new task ID
                if(task.created_date == "") 
					task.created_date = this.today; // Set new task's created date
                var data = JSON.stringify(task);
                const requestOptions = {
                    method: 'PUT',
                    headers: { 'Authorization': 'Bearer ' + localStorage.idtoken },
                    body: data 
                }
                console.log("Task to save: ", task)
                console.log("Data to save: ", requestOptions)
                try {
                    /*const response =*/ await fetch(process.env.VUE_APP_AQUACULTURE_TASKS_API_URI + "/items", requestOptions);
                    // console.log("Response from Dynamo API: ", response)
                } 
				catch (error) {
                    console.log(error);
                }
                await setTimeout(() => { // Make it looks like the table is loading
                    this.getTasksFromDB();
                }, 500)
                this.$refs['task-details-modal'].hide();
                this.$refs['new-task-modal'].hide();
                this.$refs['move-confirm-modal'].hide();
                this.savingTask = false;
            },
            async cancelTask(task) {
                this.deletingTask = true;
                this.loading = true;
                task.status = 'Canceled'; // For a 'Cancel', we're actually just setting a status of 'Canceled', rather than deleting the task.
                var data = JSON.stringify(task)
                const requestOptions = {
                    method: 'PUT',
                    headers: { 'Authorization': 'Bearer ' + localStorage.idtoken },
                    body: data
                }
                try {
                    /*const response =*/ await fetch(process.env.VUE_APP_AQUACULTURE_TASKS_API_URI + "/items", requestOptions);
                    // console.log("Response from Dynamo API: ", response)
                } 
				catch (error) {
                    console.log(error);
                }
                await setTimeout(() => { // Make it looks like the table is loading
                    this.getTasksFromDB();
                }, 500)
                this.$refs['task-details-modal'].hide();
                this.$refs['new-task-modal'].hide();
                this.deletingTask = false;
            },
            async createNewTask(){
                this.newTask.id = this.uuidv4();
                this.newTask.created_date = this.today;
                this.newTask.created_by = this.userName;
                this.newTask.start_date = this.getTodayDate();
                this.newTask.end_date = this.getTodayDate();
                await this.getHuonEquipmentFromAPI();
                this.$refs['new-task-modal'].show();
            },
            handleClickDate(date) {
                this.newTask.id = this.uuidv4();
                this.newTask.created_date = this.today;
                this.newTask.created_by = this.userName;
                this.newTask.start_date = this.formatDateToYYYYMMDD(date);

                if (this.isEditAllowed()) {
                    this.$refs['new-task-modal'].show();
                } 
            },
            taskClicked(item, index, event) {
                event.preventDefault();
                if (index >= 0) {
                    this.selectedTask = item
                    this.$refs['task-details-modal'].show();
                }
            },
            calTaskClick(item) {
                const selectedtaskcal = this.tasks.find(task => task.id === item.id);
                if (selectedtaskcal) {
                    this.selectedTask = selectedtaskcal;
                    this.$refs['task-details-modal'].show();
                }
            },
            handleDoubleClick() {
                // console.log("double click");
            },
            getStatusVariantClass(value) {
                var returnVal = 'primary';
                if (value == this.taskStatusOptions[0]) returnVal = 'primary';
                if (value == this.taskStatusOptions[1]) returnVal = 'warning';
                if (value == this.taskStatusOptions[2]) returnVal = 'info';
                if (value == this.taskStatusOptions[3]) returnVal = 'dark';
                if (value == this.taskStatusOptions[4]) returnVal = 'success';
                if (value == this.taskStatusOptions[5]) returnVal = 'danger';
                return returnVal;
            },
            visibleTaskStatusOptions() {
                return this.taskStatusOptions.filter(status => status !== 'Canceled' );
            },
            getTaskCategoryIconClass(taskCategory){
                var returnVal = '';
                if (taskCategory == this.huonTaskCategoryOptions[0]) returnVal = 'fa-solid fa-fish-fins';
                if (taskCategory == this.huonTaskCategoryOptions[1]) returnVal = 'fa-solid fa-screwdriver-wrench';
                return returnVal;
            },
            getFormattedDate(date) {
                return moment(new Date (date)).format('YYYY-MM-DD');
            },
            getRelativeDate(date) {
                return moment(new Date(date)).fromNow();
            },
            getPrioritiesVariantClass(value) {
                var returnVal = 'primary';
                if (value == 'Highest') returnVal = 'danger';
                if (value == 'High') returnVal = 'warning';
                if (value == 'Medium') returnVal = 'info';
                if (value == 'Low') returnVal = 'secondary';
                if (value == 'Lowest') returnVal = 'dark';
                return returnVal;
            },
            resetModal() {
                this.newTask.name = ''
                this.newTask.location = ''
                this.newTask.task_category = ''
                this.newTask.status = ''
                this.newTask.assigned_to = ''
                this.newTask.start_date = ''
                this.newTask.repeat = "1"
                this.newTask.due_date = ''
                this.newTask.Priority = 'Medium'
                this.newTask.task_description = ''
                this.newTask.resource = '' 
                this.newTask.equipment = []
                this.newTask.start_date = ''
                this.newTask.end_date = ''
                this.searchEquipment = ''
            },
            getfilteredItems() {
                const filteredTasks = this.tasks.filter(task => {
                    if (!this.showCompletedTasks && task.status === 'Completed') {
                        return false;
                    }
                        return !['Canceled'].includes(task.status);
                });

                const searchTermLower = this.filter ? this.filter.toLowerCase() : '';

                const filterAndSearchTasks = filteredTasks.filter(task => 
                    this.selected.includes(task.location) && 
                    this.Categoryselected.includes(task.task_category) &&
                    (!searchTermLower || 
                    (task.name && task.name.toLowerCase().includes(searchTermLower)) 
                    )
                );
                if (this.site == undefined) {
                    return filterAndSearchTasks;
                } 
                else {
                    return this.tasks.filter(task => 
                        (task.status !== 'Canceled' && (this.showCompletedTasks || task.status !== 'Completed')) &&
                        (this.site.title !== undefined && task.location == this.site.title) &&
                        this.Categoryselected.includes(task.task_category) &&
                        (!searchTermLower || (task.name && task.name.toLowerCase().includes(searchTermLower)))
                    );
                }
            },
            filtering(filteredRows) {
                this.currentPage = 1
                this.totalRows = filteredRows.length  
            },
            isEditAllowed(){
                if (this.userInfo && this.userInfo.user_additional_info) {
                    if (this.userInfo.user_additional_info.admin_user) 
						return true;
                    else {
                        if (this.userInfo.user_additional_info.user_level && this.userInfo.user_additional_info.user_level.includes('manager')) 
							return true;
                        else{
							return false;
						}
                    }
                }
                else {
					return false;
				}	
            },
            handelDropOnDate(calendarItem, date) {
                // console.log("-- DROPPED ON DATE!");
                // console.log('Date:', date);
                // console.log('Calendar Item:', calendarItem);
                // console.log('Window Event:', windowEvent);
                // console.log(calendarItem.id)
                // update Item start and end date
                var theTask = this.tasks.find(task => task.id == calendarItem.id)
                    // determine days length
                var dayLength = this.daysBetweenDates(theTask.start_date, theTask.end_date);
                // determine new start date
                var newStartDate = this.formatDateToYYYYMMDD(date);
                // determine new end date
                var newEndDate = this.increaseDateByDays(newStartDate, dayLength);
                this.newDate = newStartDate;
                this.selectedTask = { ...theTask, start_date: newStartDate, end_date: newEndDate }; // Use spread operator to copy task details
                
                if (this.isEditAllowed()) {
                    this.$refs['move-confirm-modal'].show();  
                }
                else {
                    this.$refs['errorModal'].show();  
                }
            },
            getTodayDate() {
                let today = new Date();
                let year = today.getFullYear();
                let month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so add 1 and pad with zero
                let day = today.getDate().toString().padStart(2, '0'); // Pad day with zero
                return `${year}-${month}-${day}`;
            },
            formatDateToYYYYMMDD(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            daysBetweenDates(date1, date2) {
                // Parse the dates
                const startDate = new Date(date1);
                const endDate = new Date(date2);
                // Calculate the difference in milliseconds
                const differenceInTime = endDate - startDate;
                // Convert the difference from milliseconds to days
                const differenceInDays = differenceInTime / (1000 * 3600 * 24);
                return differenceInDays;
            },
            increaseDateByDays(dateString, days) {
                // Parse the date string to a Date object
                const date = new Date(dateString);
                // Add the given number of days
                date.setDate(date.getDate() + days);
                // Format the date back to YYYY-MM-DD
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            setShowDate(d) {
                this.showDate = d;
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
            },            
            uuidv4() {
                return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
            },
            getEventStyle(event) {
                return {
                    backgroundColor: event.color,
                    color: '#fff', // Example: white text color for contrast
                    padding: '10px',
                    borderRadius: '5px',
                }
            },
            toggleAll(checked) {
                this.selected = checked ? this.huonLocationOptions.map(location => location.value) : [];
                this.updateCalendarItems();
                this.saveToLocalStorage();
            },
            updateAllColours(option) {
                this.updateCalendarItems(option);
                this.updateColor(option)
            },
            toggleAllCategories(checked) {
                this.Categoryselected = checked ? this.huonTaskCategoryOptions.map(option => option.value) : [];
                this.updateCalendarItems();
                this.saveToLocalStorage();
            }, 
            updateCalendarItems() {
                const filteredTasks = this.tasks.filter(task => task.status !== 'Canceled' && (this.showCompletedTasks || task.status !== 'Completed'))
                const searchTermLower = this.filter ? this.filter.toLowerCase() : '';
               

                const filterAndSearchTasks = filteredTasks.filter(task => 
                    (this.site && this.site.title !== undefined ? task.location === this.site.title : this.selected.includes(task.location)) &&
                    this.Categoryselected.includes(task.task_category) &&
                    (!searchTermLower || (task.name && task.name.toLowerCase().includes(searchTermLower)))                  
                        ).map(task => {
                            const color = this.huonLocationOptions.find(site => site.value == task.location).class || '#FFFFFF';
                            return {
                                id: task.id,
                                title: this.getItemTitle(task, this.equipment),
                                startDate: task.start_date,
                                endDate: task.end_date,       
                                style: `background-color: ${color}`
                            };
                });
                if ((this.site == undefined && this.selected.length === 0 && this.Categoryselected.length === 0) || 
                    (this.site && this.site.title !== undefined && filterAndSearchTasks.length === 0)) {
                    this.items = [];
                } else {
                    this.items = filterAndSearchTasks;
                }
                this.saveToLocalStorage();
                return filterAndSearchTasks;
            },
            saveToLocalStorage() {
                localStorage.setItem('selected', JSON.stringify(this.selected));
                localStorage.setItem('allSelected', this.allSelected.toString());
                localStorage.setItem('Categoryselected', JSON.stringify(this.Categoryselected));
                localStorage.setItem('allCategoriesSelected', this.allCategoriesSelected.toString());
            },         
            updateCalendarCategoryItems() {   
                // console.log(" CATEGORY " , this.Categoryselected)
            },          
            getEndDateState() {
                if (!this.selectedTask.start_date || !this.selectedTask.end_date) {
                    return false;
                }
                return (this.selectedTask.end_date > this.selectedTask.start_date || this.selectedTask.end_date == this.selectedTask.start_date  );
            },
            switchView(view) {
                this.currentView = view;
                this.updateCalendarItems();
            },
            showVitrafyLogo(shown) {
                // Find the element with the ID 'png-mate' and set its display to none
                const Vlogo = document.getElementById("vitrafy-logo");

                if (Vlogo) {
                    Vlogo.style.display = 'none' ;
                    if (shown) {
                        Vlogo.style.display = 'block';
                    } 
					else {
                        Vlogo.style.display = 'none';
                    }
                }
            },
            showVitrafyLock(shown) {
				const Vlock = document.getElementById("lock-image");
                if (Vlock) {
                    Vlock.style.display = 'none' ;
                    if (shown) {
                        Vlock.style.display = 'block';
                    } 
					else {
                        Vlock.style.display = 'none';
                    }
                }
            },
            TasksPaddingRemove(shown){
                const Taskspadding = document.getElementById("dashboard-container");
                if (Taskspadding) {
                    Taskspadding.className = '' ;
                    if (shown) {
                        Taskspadding.className = 'col-md-auto ms-sm-auto col-lg-11 px-md-1';
                    } 
					else {
                        Taskspadding.className = '';
                    }
                }
            },
            TaskGridRemove(shown){
                const Tasksgridcontainer = document.getElementById("dashboard-grid-container");
                if (Tasksgridcontainer) {
                    Tasksgridcontainer.className = '' ;
                    if (shown) {
                        Tasksgridcontainer.className = 'grid-container';
                    } else {
                        Tasksgridcontainer.className = '';
                    }
                }
            },
            openColourModal() {
                this.$refs.colour.show();
            },
            // changeScreenWidth(){ 
            //     this.ScreenWidthState = !this.ScreenWidthState;
            //     const tempState =  !this.ScreenWidthState;
            //     this.showVitrafyLogo(tempState);
            //     this.showVitrafyLock(tempState);
            //     this.TasksPaddingRemove(tempState);
            //     this.TaskGridRemove(tempState);
            // }

            isDarkColor(hex) {
                // Remove the hash at the start if it's there
                hex = hex.toString().replace('#', '');
                // Convert to RGB values
                let r = parseInt(hex.substring(0, 2), 16);
                let g = parseInt(hex.substring(2, 4), 16);
                let b = parseInt(hex.substring(4, 6), 16);

                // Calculate brightness (http://www.w3.org/TR/AERT#color-contrast)
                let brightness = (r * 299 + g * 587 + b * 114) / 1000;

                // A threshold for brightness; you might want to adjust this value
                return brightness < 128;
            },
            copyTask(task) {
                const newTask = { ...task, id: this. uuidv4() }; // Generate a new ID for the copied task
                this.saveTaskDetails(newTask); 
                this.updateCalendarItems();
                this.$refs['move-confirm-modal'].hide();
            },
            updateColor(site) {
    
                let siteToChange = this.sites.find(siteToFind => siteToFind.id === site.label);
                siteToChange.calendar_category_colour = site.class.hex;
                siteToChange.EventColourClass = site.class.hex;

                this.saveSiteDetails(siteToChange);
                this.huonLocationOptions = this.huonLocationOptions.map(option => {
                    if (option.value === site.label) {
                        return { ...option, class: site.class.hex, EventColourClass: site.class.hex };
                    } 
                    else {
                        return option;
                    }
                });
                 
            }, 
            async saveSiteDetails(site) {
                try {
                    await this.$http.put(
                        process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                        { "TableName": "aquaculture_sites", "Item" : site },
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );                      
                } 
				catch (error) {
                    console.log(error);
                }               
                this.updateCalendarItems();
            },
            checkDateDifference() {
                const startDate = new Date(this.newTask.start_date);
                const endDate = new Date(this.newTask.end_date);
                // Adjust the day of the week to start from Monday (0 = Monday, 6 = Sunday)
                const adjustedStartDay = (startDate.getDay() + 6) % 7;
                const adjustedEndDay = (endDate.getDay() + 6) % 7;
                // Calculate the difference in days
                const diffTime = Math.abs(endDate - startDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                // Check if the dates are within the same week
                const sameWeek = diffDays < 7 && adjustedStartDay <= adjustedEndDay;
                this.showRepeatInput = sameWeek;
            },
            saveSelectedTask() {
                this.saveTaskDetails(this.selectedTask);
                this.updateCalendarItems(); 
            },
            async createAndRepeatTask() {
                await this.saveTaskDetails(this.newTask);   
                
                // Calculate the time difference between start and end dates in milliseconds Due to Daylight saving errors
                const startDate = moment(this.newTask.start_date).hours(12).minutes(0).seconds(0).milliseconds(0);
                const endDate = moment(this.newTask.end_date).hours(12).minutes(0).seconds(0).milliseconds(0);
                const diffTime = endDate - startDate;

                // Repeat task creation based on the repeat count
                for (let i = 1; i < this.newTask.repeat; i++) {
                    const newStartDate = new Date(startDate);
                    newStartDate.setDate(newStartDate.getDate() + 7 * i);

                    const newEndDate = new Date(newStartDate);
                    newEndDate.setTime(newStartDate.getTime() + diffTime);
                    const repeatedTask = {
                        ...this.newTask,
                        id: this.uuidv4(),
                        start_date: newStartDate.toISOString().split('T')[0],
                        end_date: newEndDate.toISOString().split('T')[0],
                    };
                    await this.saveTaskDetails(repeatedTask);
                }    
            },                         
            itemMouseEnter(calendarItem, event) {
                event.target.setAttribute('title', calendarItem.originalItem.startDate + ' - ' + calendarItem.originalItem.endDate);	
            },
            itemMouseLeave(calendarItem, event) {
                event.target.setAttribute('title', calendarItem.originalItem.title);
            },
            addEquipmentTag({ equipment, addTag }) {
                const tag = `${this.equipmentQuantity} x ${equipment}`;
                addTag(tag);
                this.searchEquipment = '';
                this.equipmentQuantity = 1; 
            },
            handleEquipmentSearchInput() {
                this.searchEquipmentDropDownVisible = this.searchEquipment.length > 0;
                this.filteredEquipmentOptions = this.getfilteredEquipmentOptions.filter(option =>
                    option.toLowerCase().includes(this.searchEquipment.toLowerCase())
                );
            },
            onEquipmentOptionClick(option) {
                this.searchEquipment = option;
                this.searchEquipmentDropDownVisible = false;
            },
            hideDropDown() {
                this.searchEquipmentDropDownVisible = false;
            },      
            setPeriodCount(count) {
                this.displayPeriodCount = count;
            },
            // Equipment Table functions
            insertEquipment() {
                if (!this.hasEquipmentsItemsInEdit) {
                    const newItem = {
                        Name: this.equipmentTable.Name,
                        Units: this.equipmentTable.Units,
                        Location:  this.equipmentTable.Location,
                        active: this.equipmentTable.active,
                        inEdit : true,
                        isNew : true,
                    };
                    this.equipmentTableData.unshift(newItem);
                    this.hasEquipmentsItemsInEdit = true;
                }
            },
            updateEquipment(item) {
                item.inEdit = false; 
                item.isNew = false; 
                this.hasEquipmentsItemsInEdit = false;
                const editEquipmentDetails = {
                    id: item.id,  
                    organisation: 'Huon',
                    name: item.Name,
                    units: item.Units,
                    location: item.Location,
                    active: item.active,
                    type: '',  
                    sites: [], 
                };
                // console.log('Edit Equipment Details:', editEquipmentDetails);
                this.saveEquipmentDetails(editEquipmentDetails);
            },
            saveNewEquipment(item) {
                item.inEdit = false; 
                item.isNew = false;
                this.hasEquipmentsItemsInEdit = false;
                const newEquipmentDetails = {
                    id: this.uuidv4(),
                    organisation: 'Huon',
                    name: item.Name,
                    units: item.Units,
                    location: item.Location,
                    active: item.active,
                    type: '',
                    sites: []
                };
                this.saveEquipmentDetails(newEquipmentDetails);
            },
            discardEquipment(item) {
                const index = this.equipmentTableData.indexOf(item);
                if (index !== -1) {
                    this.equipmentTableData.splice(index, 1);
                }
                this.hasEquipmentsItemsInEdit = false;
            },
            cancelEquipmentEdit(item) {
                const index = this.equipmentTableData.indexOf(item);
                if (index !== -1) {
                    Object.assign(item, this.originalData[index]); 
                }
                item.inEdit = false;
                this.hasEquipmentsItemsInEdit = false;
            },
            editEquipment(item) {
                const index = this.equipmentTableData.indexOf(item);
                if (index !== -1) {
                    this.originalData[index] = { ...item };
                }
                item.inEdit = true;
                item.isNew = false; 
                this.hasEquipmentsItemsInEdit = true;
            },
            isEquipmentEditAllowed() {
                return true; 
            },
            toggleEquipmentActiveStatus(item){
                item.active = !item.active;
                this.updateEquipment(item);
            },
        },
        watch: {  
            filter: function() {
                this.updateCalendarItems();
            },
            'newTask.start_date'(newValue) {
                this.newTask.end_date = newValue;
            },    
            selected(newValue) {
                if (newValue.length === 0) {
                    this.allSelected = false;
                } 
				else if (newValue.length === this.huonLocationOptions.length) {
                    this.allSelected = true;
                } 
				else {
                    this.allSelected = false;
                }
                this.updateCalendarItems();
            },         
            Categoryselected(newValue) {
                if (newValue.length === 0) {
                    this.allCategoriesSelected = false;
                }
				else if (newValue.length === this.huonTaskCategoryOptions.length) {
                    this.allCategoriesSelected = true;
                } 
				else {
                    this.allCategoriesSelected = false;
                }
                this.updateCalendarItems();
            },      
            searchEquipment(newValue) {
                if (newValue === '') {
                this.hideDropDown();
                }
            },
        }
    };
</script>


<style>
.scrollable-container {
    position: relative; /* Ensures the button is positioned relative to this container */
    overflow: hidden; /* or overflow: scroll; */
    max-height: 680px; /* or any desired height */
    padding: 10px;
    display: flex;
    flex-direction: column;
}

#colour-picker-button{
    margin-right: 100px;
}

#searchTask{
    padding-right: 10px;

}

#focusButton{
    background-color: #ffff;
    color: black ;
    border-color: #c7f3f7;
    margin-right: 45px;
}

.pagination-table-tasks {
    display: flex;
    float: right;
}

.table-search {
    position: relative;
    right: 0;
    margin-right: 5px;
    top: 22px;
}

#dropdown-1 {
    /* Adjust padding */
    font-size: 12px; /* Adjust font size */
}

.new-task:hover {
    text-decoration: underline;
    cursor: pointer;
}

.button-conatiner {
    display: flex;
    justify-content: flex-end;
    align-content: right;
    margin-top: -10px;
}

#create-new-task-button {
    display: flex;
    justify-content: flex-end;
    align-content: right;
    margin-top: -5px;
    position: absolute;
    right: 0;
    z-index: 1;
    margin-right: 25px;
}

#tasks-table-mobile {
    display: none;
}

/* .modal-new{
        overflow: hidden;
    } */

/* .modal-edit{
        overflow: hidden;
    } */

/* .d-block{
        height: auto !important;
        max-height: calc(100vh - 340px) !important;
        overflow-y: scroll; 
    } */

.content-row {
    align-items: center;
    align-content: center;
    padding: 3px;
    margin-right: 80px;
}

#filter-containers{
    margin-top: 60px; 
    margin-left: 10px
}

#calendarview {
    min-height: 600px;
    max-height: 600px;
    margin-top: 10px;
    height: auto;
    min-width: 100%;
    background-color: white;
}
#current-view-button{
    position: absolute; 
    right: 0; 
    top: 2px; 
    margin-right: 30px;
}

#calendar-period-select{
    position: absolute; 
    right: 0; 
    top: 2px;
    margin-right: 150px;
}

#calendar-month-text{
    font-size: 20px;
    text-align: center;
}


#table-desktop {
    min-height: 620px;
    max-height: 620px;
    min-width: 100%;
    margin-top: -5px;
    overflow: auto;
    scrollbar-width: thin;
}

#equipment-table {
    min-height: 600px;
    max-height: 600px;
    min-width: 100%;
    margin-top: -5px;
    overflow: auto;
    scrollbar-width: thin;
}

.circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

#Calendar-Tasks-Container {
    overflow: auto;
    margin-top: -20px;
}

#new-item-button {
    margin-bottom: 20px;
}

/* item colours */
.redwood {
    background-color: #77ca6d !important;
}

.earth-yellow {
    background-color: #729cdf !important;
}

.asparagus {
    background-color: #d56c19 !important;
    color: white;
}

.air-force-blue {
    background-color: #f6bcbc !important;
}

.lemon-chiffon {
    background-color: #4d3b8f !important;
    color: white;
}

.african-violet {
    background-color: #d98b89 !important;
}

.coral-pink {
    background-color: #f09f54 !important;
}

.melon {
    background-color: #f5ed63 !important;
}

.magenta-haze {
    background-color: #184d8d !important;
    color: white;
}

.chamoisee {
    background-color: #9480d0 !important;
}

.argentinian-blue {
    background-color: #e9c865 !important;
}

.khaki {
    background-color: #4c607d !important;
    color: white;
}

.switchGreen{
    color: #77ca6d !important;
}

.switchRed{
    color: #f15337 !important;
}

/* mini cal */
#mini-cal__calendar-grid_ {
    margin-top: 0px;
}

#mini-cal__calendar-grid_:focus {
    outline: none !important;
    box-shadow: none !important;
}

.b-calendar-grid {
    border: none !important;
    padding: 5px !important;
}

#mini-cal__calendar-wrapper_ header {
    display: none !important;
}

#task-cal-container {
    margin-top: 5px;
}

#separating-line {
    max-width: 270px;
}

#mini-cal__calendar-grid_ span.btn {
    width: 21px !important;
    height: 21px !important;  
    font-size: 11px !important;
    line-height: 1 !important;
    margin: 3px auto !important;
    padding: 5px 0 !important;
}

#mini-cal__calendar-nav_ {
    display: none !important;
    min-width: 200px;
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
}
.b-calendar-grid-help {
    display: none;
}

.scrollable-container-location {
    max-height: 190px;
    overflow-y: auto;
    scrollbar-width: thin; /* Width of the scrollbar */
    max-width: 200px;
}

.scrollable-container-Category {
    max-height: 300px;
    overflow-y: auto; /* This enables vertical scrolling */
    scrollbar-width: thin; /* Width of the scrollbar */
}

#showCompletedTaskcheckbox{
    margin-left: 5px;
    margin-top: -70px;
    padding-bottom: 10px;
}

.strikethrough {
  text-decoration: line-through;
}

.custom-dropdown:hover {
  background-color: rgb(231, 229, 229) !important;
}
/* #site-filter {
        /* margin-top: 20px;;
        margin-left: 5px;
        margin-bottom: 10px; */

.dropdown-container {
  max-height: 200px; /* Adjust as needed */
  overflow-y: auto;
}


@media (max-width: 767px) {
    main.col-md-auto.ms-sm-auto.col-lg-11.px-md-1 {
        padding: 0 !important;
    }

    .scrollable-container {
        min-height: 1500px;
        max-height: 1500px; /* or any desired height */
        display: flex;
        flex-direction: column;
    }

    #focusButton{
        display: none;
    }

    #separating-line {
        display: none;
    }

    #calendar-period-select{
        display: none;
    }

    #searchTask{
        padding-right: 10px;
        max-width: 200px;
    }

    #create-new-task-button {
        position: absolute;
        right: 0;
        top: 25px;
        order: 1;
    }

    #calendar-month-text{
        font-size: 18px;
        text-align: center;
        padding-left: 15px;
    }

    #Calendar-Tasks-Container {
        margin-top: 10px;
        order: 2;
    }

    #current-view-button{
        position: absolute; 
        right: 0; 
        top: 2px; 
        margin-right: 2px;
    }

    #filter-containers{
        margin-left: 10px
    }

    #show-items {
        position: absolute;
        left: 0;
        top: 6%;
        margin-right: 43%;
    }

    .button-conatiner {
        margin-bottom: 10px;
    }

    #search-box-container {
        position: absolute;
        left: 0;
        top: 3%;
    }

    #content {
        max-width: 100% !important;
    }
    
    .scrollable-container-location{
        max-height: 200px;
        overflow-y: auto; 
        scrollbar-width: thin; 
        min-width: 300px;
        max-width: 300px;
    }

    .scrollable-container-Category{
        max-height: 250px;
        overflow-y: auto; 
        scrollbar-width: thin; 
        min-width: 300px;
        max-width: 300px;
    }

    #table-navigation {
        display: none;
    }

    #search-box-container {
        position: absolute;
        right: 0;
        padding-bottom: 20px;
        margin-right: 40%;
    }
    /* .modal-new{
            overflow: hidden;
        } */

    /* .modal-edit{
            overflow: hidden;
        } */

    .modal-body {
        overflow: auto;
    }

    .form-row {
        display: block;
    }

    .form-row label {
        text-align: left !important;
    }

    .grid-container {
        padding-bottom: 100px;
    }

    .d-block {
        height: auto !important;
        max-height: calc(100vh - 135px) !important;
        overflow-y: scroll;
    }

    .form-row {
        min-width: 75%;
        padding-right: 10px;
    }

    .content-row {
        align-items: center;
        align-content: center;
        padding: 3px;
        margin-right: 10px;
    }

    #modal-footer {
        height: 20px;
        float: right;
        width: 100%;
    }

    #table-desktop {
        display: none;
    }

    #tasks-table-mobile {
        display: table;
    }

    .table-search {
        margin-bottom: 0;
    }

    #table-navigation-mobile {
        display: block;
        float: right;
    }
    #calendarview {
        margin-right: 0px;
        
    }

    /* mini cal */
    #mini-cal__calendar-grid_ {
        display: none !important;
    }

    #mini-cal__calendar-grid_:focus {
        outline: none !important;
        box-shadow: none !important;
    }

    #mini-cal__calendar-wrapper_ header {
        display: none !important;
    }

    .b-calendar-grid {
        display: none;
    }

    #mini-cal__calendar-nav_ {
        display: none;
    }

    #showCompletedTaskcheckbox{
        margin-top: -50px !important;
        padding-bottom: 10px;
        margin-left: -3px !important;
    }
}

.category-item {
    position: relative;
}

.category-dot {
    position: absolute;
    top: 5px;
    left: 0;
    height: 12px;
    width: 12px;
    background-color: gray;
    border-radius: 50%;
    display: inline-block;
}

.location-background-preview {
    position: absolute;
    left: 0;
    height: 30px;
    width: 100%;
    background-color: gray;
    border-radius: 0.5em;
    display: inline-block;
}

.category-label {
    margin-left: 20px;
}

.cv-day.today {
    background-color: #fff !important;
}

.cv-item {
    align-content: left; /* Ensure text alignment is to the left */
    text-align: center;
}

.cv-day.today div.cv-day-number {
    background-color: #0262cc !important;
    color: white !important;
    font-weight: bold;
}

.week-view .cv-item {
  height: 100px;
  padding: 10px;
  text-align: left;
}

#calendarview .calendar-item {
    pointer-events: auto;
    cursor: pointer;
}

.cv-week {
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    flex-flow: row nowrap;
    border-width: 0;
    position: relative;
    width: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
}

.cv-item .tooltip {
    display: none;
}

.cv-weekdays {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    flex-flow: row nowrap;
    direction: ltr;
    position: relative;
    overflow-y: auto;
    scrollbar-width: none;
}

.cv-header {
    display: none !important;
}

div[id^="mini-cal__cell-"] .btn-outline-primary {
    --bs-btn-color: #fff !important;
    background-color: #0262cc !important;
}
</style>
